module.exports = __webpack_public_path__ + "static/img/BN.46907678.svg";